import { Loader, EmptyComponent } from "processhub-components-lib";
import React from "react";
import TextOverflow from "../../../../utilities/TextOverflow";
import { useState, useEffect } from "react";
import classNames from "../../../../utilities/ClassNames";
import Chart from "../../../NewDashboard/Chart1";
import { cn } from "../../../../@/lib/utils";
import { LargeProps } from "./domain/types";
import truncateText from "../../../../utilities/truncateText";

const Large: React.FC<LargeProps> = ({ tab, largeConfig, hooks }) => {
  const { useData } = hooks;
  const { getTagData, getExpressionData, areaApiConfig } = largeConfig;
  const { pastDate } = useData();
  const data = tab.configurations;
  const [processedData, setProcessedData] = useState<any[]>([]);
  const [current, setCurrent] = useState(0);
  const namesCollection = Object.entries(data).map((singleItem: any) => singleItem[1]?.name);

  useEffect(() => {
    const fetchData = async () => {
      const dataArray = Object.entries(data).map((item) => item[1]);
      const promises = dataArray.map(async (single: any) => {
        if (single.id !== '') {
          const response = single?.type === 'tags' ? await getTagData([single?.id], pastDate) : await getExpressionData([single?.id], pastDate);
          if (response.status === 200) {
            return response.data[0];
          }
        }
        return null;
      });
      const results = await Promise.all(promises);
      setProcessedData(results);
    };

    fetchData();
    const intervalId = setInterval(fetchData, 15000);
    return () => clearInterval(intervalId);
  }, [data, pastDate]);

  return (
    <>
      {!data && (
        <div className="w-full h-full grid place-content-center">
          <Loader />
        </div>
      )}
      <div className="h-full flex flex-wrap">
        <div className={classNames("flex gap-2 w-max h-[20%] ml-2 bg-dark rounded-md p-1.5")}>
          {processedData.map((item: any, index: any) => (
            item ? (
              <div
                key={index}
                className={cn(current === index ? "bg-[#FFFFFF33]/20" : "", "p-3 px-5", "rounded-md flex items-center justify-center cursor-pointer")}
                onClick={() => setCurrent(index)}
              >
                <div className="flex flex-col">
                  <p
                    className={classNames("text-white sm:text:md 2xl:text-lg",
                      "capitalize font-bold text-center whitespace-nowrap"
                    )}
                  >
                    {truncateText(namesCollection[index] || item.name, window.innerWidth <= 1700 ? 15 : 25)}
                  </p>
                  <div className="flex gap-1 justify-center">
                    {item.value ? (
                      <p className={cn("text-white font-semibold", "sm:text-md 2xl:text-xl")}>
                        {item?.uom === "%"
                          ? TextOverflow(item.value.toFixed(2), 7)
                          : TextOverflow(item.value.toFixed(2), 7)}
                      </p>
                    ) : (
                      <p className="text-white font-semibold sm:text-md 2xl:text-xl">
                        {TextOverflow(item.formattedValue, 7)}
                      </p>
                    )}
                    {item.value && (
                      <p className="text-white font-semibold sm:text-md 2xl:text-lg self-end">
                        {item?.uom}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <EmptyComponent key={index} />
            )
          ))}
        </div>
        <div className="w-full h-[80%] flex gap-3">
          <div className={classNames("w-full h-full", "flex justify-center items-center")}>
            {processedData.map((item: any, index: any) => (
              current === index && (
                <div key={index} className="w-full flex h-full justify-center items-center">
                  <Chart data={item} name={namesCollection[index]} areaApiConfig={areaApiConfig} />
                </div>
              )
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(Large);
